import { createFileRoute } from "@tanstack/react-router";
import { DashboardPage } from "@/features/dashboard/components/DashboardPage";

/**
 * Dashboard del portal · landing tras el login. La lógica vive en el
 * feature `dashboard/`. Primera pantalla movida al layout Tailwind
 * (`_authed-tw`, ver ese archivo para el porqué).
 */
export const Route = createFileRoute("/_authed-tw/dashboard")({
  component: DashboardPage,
});
